<template>
    <!-- 레이어 팝업 .pop_event_04 이미 응모한 시작 -->
    <div class="layerWrapper pop_event_01" @click="close" style="display:block;">
        <div class="cbox layerBox popWidM" style="opacity:10;position:relative;top:30%;">
            <div class="cart-popup__dialog">
            <div class="cart-popup__content height-auto">
                <div class="cart-popup__item-info" style="padding:0">
                <div class="os_noticeRes" data-btn-close="closeLayer">
                    <div class="padS txtC" style="background-color:#50b4b8;color:#fff">
                    <div class="padSM padBM" style="border:2px solid #fff;border-radius:18px">
                        <div><img src="https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/logo_03.png" alt="Artistry Skin Nutrition(로고)" style="max-width:129px;min-width:60px;width:35%"></div>
                        <template v-if="type == '1'">  
                            <div class="marTM"><img src="https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/ico_01.png" alt="" class="icoXS"></div>
                            <p class="marTSM fntH6 fntL">
                                <strong>본 이벤트는 {{message}} 부터<br>신청 가능합니다.</strong>
                            </p>
                        </template>
                        <template v-if="type == '2'">  
                            <div class="marTM"><img src="https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/ico_02.png" alt="" class="icoXS"></div>
                            <p class="marTSM fntH6 fntL">
                                <strong>이벤트 신청 완료 되었습니다.</strong>
                            </p>
                        </template>
                        <template v-if="type == '3'">  
                            <div class="marTM"><img src="https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/ico_03.png" alt="" class="icoXS"></div>
                            <p class="marTSM fntH6 fntL">
                                <strong>본 이벤트는 종료되어 <br>신청하실 수 없습니다.</strong>
                            </p>
                        </template>
                        <template v-if="type == '4'">
                            <div class="marTM"><img src="https://www.amway.co.kr/_ui/_noticeImg/2022/01/0107_ev_skin_nutrition/ico_04.png" alt="" class="icoXS"></div>
                            <p class="marTSM fntH6 fntL">
                                <strong>{{message}}</strong>
                            </p>
                        </template>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    <!-- //레이어 팝업 .pop_event_04 이미 응모한 끝 -->

</template>


<script>

export default ({
  props: ['message', 'type']
  , methods : {
      close : function () { 
          this.$emit('close')
      }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/nutrilite/relayevent/component/popupMessage.vue